import React from 'react';
import { FM210 } from '../../../services/m207Api';
import LookupField from '../../../components/LookupField';

interface Tab1Props {
  formData: Partial<FM210>;
  isEditing: boolean;
  getField: (key: keyof FM210) => FM210[keyof FM210];
  setField: (key: keyof FM210, value: FM210[keyof FM210]) => void;
  isApproved: boolean;
}

/** Helper: convert ISO date string to input value */
const dateToInput = (v: FM210[keyof FM210]): string => {
  if (!v) return '';
  const s = String(v);
  return s.length >= 10 ? s.substring(0, 10) : s;
};

const Tab1BasicInfo: React.FC<Tab1Props> = ({ formData, isEditing, getField, setField, isApproved }) => {
  const isDisabled = !isEditing;

  return (
    <div className="m207-master-fields">
      {/* Row 1: 修改單號 + 已核准 + 修改日期 */}
      <div className="field-row">
        <div className="field-pair">
          <label>修改單號</label>
          <input type="text" readOnly value={(getField('fm210_01') as string) || ''} style={{ maxWidth: 120 }} />
          {isApproved && <span className="approved-label">已核准</span>}
        </div>
        <div className="field-pair">
          <label>修改日期</label>
          <input
            type="date"
            disabled={isDisabled}
            value={dateToInput(getField('fm210_11'))}
            onChange={e => setField('fm210_11', e.target.value || null)}
            style={{ maxWidth: 160 }}
          />
        </div>
      </div>

      {/* Row 2: 庫位代號 + 入單人員 */}
      <div className="field-row">
        <div className="field-pair">
          <label className="required">庫位代號</label>
          <LookupField
            lookupType="warehouse"
            maxLength={5}
            disabled={isDisabled}
            value={(getField('fm210_14') as string) || ''}
            onChange={v => setField('fm210_14', v)}
            onCodeConfirm={v => setField('fm210_14', v)}
            style={{ maxWidth: 100 }}
          />
        </div>
        <div className="field-pair">
          <label>入單人員</label>
          <input type="text" readOnly value={(getField('fm210_12') as string) || ''} style={{ maxWidth: 120 }} />
        </div>
      </div>

      {/* Row 3: 部門代號 */}
      <div className="field-row">
        <div className="field-pair">
          <label>部門代號</label>
          <input type="text" readOnly value={(getField('fm210_13') as string) || ''} style={{ maxWidth: 120 }} />
        </div>
      </div>
    </div>
  );
};

export default Tab1BasicInfo;
